export class GoogleWorkspaceUserDriveEntireDriveOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUserDriveEntireDriveOptions.attributeTypeMap;
    }
    constructor() {
    }
}
